import { StandaloneNounCircular, StandaloneBigNounCircular } from '../../components/StandaloneNoun';
import { BigNumber as EthersBN } from 'ethers';
import classes from './NounImageVoteTable.module.css';
import { GrayCircle } from '../GrayCircle';
import { pseudoRandomPredictableShuffle } from '../../utils/pseudoRandomPredictableShuffle';

interface NounImageVoteTableProps {
  nounIds: string[];
  propId: number;
  isNounsDAOProp?: boolean;
}
const NOUNS_PER_VOTE_CARD_DESKTOP = 15;

const isXLScreen = window.innerWidth > 1200;

const NounImageVoteTable: React.FC<NounImageVoteTableProps> = props => {
  const { nounIds, propId, isNounsDAOProp } = props;

  const shuffledNounIds = pseudoRandomPredictableShuffle(nounIds, propId);
  const paddedNounIds = shuffledNounIds
    .map((nounId: string) => {
      if (isNounsDAOProp) {
        return <StandaloneBigNounCircular nounId={EthersBN.from(nounId)} />;
      }
      return <StandaloneNounCircular nounId={EthersBN.from(nounId)} />;
    })
    .concat(Array(NOUNS_PER_VOTE_CARD_DESKTOP).fill(<GrayCircle />))
    .slice(0, NOUNS_PER_VOTE_CARD_DESKTOP);

  const content = () => {
    const rows = 3;
    const rowLength = isXLScreen ? 5 : 4;

    return Array(rows)
      .fill(0)
      .map((_, i) => (
          <thead>
            <tr>
              {Array(rowLength)
                .fill(0)
                .map((_, j) => (
                  <td key={i}>{paddedNounIds[i * rowLength + j]}</td>
                ))}
            </tr>
          </thead>
      ));
  };

  return <table className={classes.wrapper}>{content()}</table>;
};

export default NounImageVoteTable;
